const VIDToDevice = new Map()
VIDToDevice.set(6785, "98KTZ")

export default VIDToDevice